import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import InvoiceWithToken from 'components/public/InvoiceWithToken/InvoiceWithToken';

const Complete = withLazyFallback(() => import('components/InstantActions/components/Complete'));
const CustomForms = withLazyFallback(
  () => import('components/InstantActions/components/CustomForms')
);
const InstantAuth = withLazyFallback(
  () => import('components/InstantActions/components/InstantAuth')
);
const InstantPacket = withLazyFallback(
  () => import('components/InstantActions/components/InstantPacket')
);
const InstantActionPage = withLazyFallback(() => import('components/InstantActions/wrapper'));
const NotFound = withLazyFallback(() => import('components/NotFound'));
const PersonalId = withLazyFallback(
  () => import('components/Patient/checkin/PersonalId/PersonalId')
);
const PersonalInformationContainer = withLazyFallback(
  () => import('components/Patient/checkin/PersonalInfo/PersonalInfo')
);
const PreAuth = withLazyFallback(() => import('components/Patient/checkin/PreAuth'));
const ReturnCheck = withLazyFallback(() => import('components/Patient/checkin/ReturnCheck'));
const HipaaFormContainer = withLazyFallback(
  () => import('components/Patient/checkin/hipaa_form_container')
);
const Insurance = withLazyFallback(() => import('components/Patient/checkin/insurance'));

const INSTANT = [
  { path: 'ia/:token', element: <InstantActionPage /> },
  { path: 'ia/auth/:token', element: <InstantAuth /> },
  { path: 'invoice/:token', element: <InvoiceWithToken /> },
  {
    path: 'instant-packet',
    element: <InstantPacket />,
    children: [
      { path: 'personal-info', element: <PersonalInformationContainer /> },
      { path: 'form/:id', element: <CustomForms /> },
      { path: 'hipaa', element: <HipaaFormContainer /> },
      { path: 'personal-id', element: <PersonalId /> },
      { path: 'insurance', element: <Insurance /> },
      { path: 'pre-auth', element: <PreAuth /> },
      { path: 'complete', element: <Complete /> },
      { path: 'return-check', element: <ReturnCheck /> },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default INSTANT;
